// Where offline card search exists at all (W5): ONLY the Android app (the
// TWA) and an installed PWA (display-mode standalone, or iOS Safari's
// navigator.standalone). A normal browser tab never downloads card data,
// never shows the download control and never falls back to it: its
// behavior is exactly what it was before offline search existed.
import { isAndroidApp } from '../androidApp'
import { STANDALONE_QUERY } from './offlineCards.codes'

function standalone(): boolean {
  try {
    if (typeof window.matchMedia === 'function' && window.matchMedia(STANDALONE_QUERY).matches) return true
  } catch {
    // no matchMedia: fall through
  }
  return (navigator as Navigator & { standalone?: boolean }).standalone === true
}

export function offlineCardsEligible(): boolean {
  if (typeof window === 'undefined' || typeof navigator === 'undefined') return false
  return isAndroidApp() || standalone()
}
